/* eslint-disable no-unused-vars */
import { getAllowedItemsList } from '../@helper_functions/helpers';

// !============================
// ! Deletion State initializer:
// !============================
export const stateInitializer = () => ({
  isDeletionModeActive: false,
  isDeleteConfirmationActive: false,
  data: [],
  itemsAllowedToDelete: [],
  selectedItems: [],
  selectedItemsCount: 0,
  idName: '',
  userInfo: {},
  tableCode: '',
  isCheckedAll: false,
});

// !===================
// ! Action functions:
// !===================
//* Activate deletion mode:
export const activateDeletionMode = (state) => ({ isDeletionModeActive: true });

//* Deactivates deletion mode.
export const deactivateDeletionMode = (state) => ({
  isDeletionModeActive: false,
  isDeleteConfirmationActive: false,
  selectedItems: [],
  selectedItemsCount: 0,
});

//* Reset deletion state, re-initializes the state to the defaults except the userInfo:
export const resetDeletionState = (state) => ({
  ...stateInitializer(),
  userInfo: state.userInfo,
});

//* Update deletion state:
export const updateDeletionState = (state, payload) => ({ ...payload });

//* Add item's id to the selected items array:
export const toggleAddRemoveItemsFromSelectedList = (state, payload) => {
  const newSelectedItemsList = !state.selectedItems.includes(payload.id)
    ? [...state.selectedItems, payload.id]
    : state.selectedItems.filter((item) => item !== payload.id);

  const selectedItemsCount =
    updateSelectedItemsCount(newSelectedItemsList) || 1;
  const isCheckedAll =
    newSelectedItemsList.length === state.itemsAllowedToDelete.length;

  return {
    selectedItems: newSelectedItemsList,
    ...selectedItemsCount,
    isCheckedAll,
  };
};

//* Remove item's id from the selected items array:
export const removeItemFromSelectedItems = (state, payload) => ({
  selectedItems: state.selectedItems.filter((id) => id !== payload.id),
});

//* Update selected items count:
export const updateSelectedItemsCount = (list) => ({
  selectedItemsCount: list.length,
});

//* Update user info:
export const updateUserInfo = (state, payload) => ({ userInfo: payload });

//* Update items allowed to deleted:
export const setItemsAllowedToDeleteList = (state) => ({
  itemsAllowedToDelete: getAllowedItemsList(state),
});

//* Update the state after successful deletion, by resetting the selectedItems array and the selectedItemsCount and keeping the user info:
export const updateStateAfterSuccessfulDeletion = (state) => ({
  selectedItems: [],
  selectedItemsCount: 0,
  isDeletionModeActive: false,
  isDeleteConfirmationActive: false,
});

//* Update the data array:
export const updateData = (state, payload) => {
  return {
    data: payload.data,
    itemsAllowedToDelete: getAllowedItemsList(state),
  };
};

//* Check all allowed items to delete in the current table view:
export const toggleCheckAllItems = (state) => {
  if (state.itemsAllowedToDelete.length > 0 && !state.isCheckedAll) {
    return {
      isCheckedAll: true,
      selectedItems: [...state.itemsAllowedToDelete],
      selectedItemsCount: state.itemsAllowedToDelete.length,
    };
  } 
    return {
      isCheckedAll: false,
      selectedItems: [],
      selectedItemsCount: 0,
    };
  
};

//* Update AppState to force re-render the page:
export const updateAppState = (payload) => {
  const { appStateSetter } = payload;
  appStateSetter((prevState) => ({
    ...prevState,
  }));
};



// WEBPACK FOOTER //
// ./src/MultiDeletionFunctionality/@state_manager/reducer_helpers.js